<title direction="left" [style]="{ 'font-size': '16px', color: '#3376F6' }">
  Étape 03 : confirmez la répartition des montants.
</title>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <div class="horizontal-scrollable">
              <div class="row">
                <div class="col-md-12">
                  <pr-panel>
                    <div class="man pr-panel">
                      <pr-panel-body>
                        <div class="pr-panel-body undefined">
                          <div
                            class="pr-card-swiper animated fadeIn relative overflow-hidden"
                          >
                            <table
                              class="pr-table-card-container"
                              style="width: 100%"
                            >
                              <thead
                                class="pr-table-card-row-container pr-table-card-headings borderRadiusLeft"
                              >
                                <th class="grid-span-3 ng-star-inserted">
                                  <span
                                    class="pr-table-card-cell text-ellipsis uppercase"
                                  >
                                  </span>
                                </th>
                                <th class="grid-span-2 ng-star-inserted">
                                  <span
                                    class="pr-table-card-cell text-ellipsis uppercase"
                                  >
                                  </span>
                                </th>
                                <th class="grid-span-4 ng-star-inserted">
                                  <span
                                    class="pr-table-card-cell text-ellipsis uppercase"
                                    >VERSEMENT PROGRESSIF
                                    {{
                                      options?.parameters
                                        ?.avOptionInvestissementProgressifMontantArbitrage
                                    }}
                                    €
                                  </span>
                                </th>
                                <th></th>
                              </thead>
                              <tbody class="pr-table-card-statistics-body">
                                <ng-container
                                  formArrayName="avOptionInvestissementProgressifRepartition"
                                >
                                  @for (
                                    repartition of avOptionInvestissementProgressifRepartition.controls;
                                    track repartition;
                                    let index = $index
                                  ) {
                                    <ng-container [formGroup]="repartition">
                                      <div
                                        class="pr-table-card-row ng-star-inserted"
                                      >
                                        <div
                                          class="pointer pr-table-card-row-container"
                                        >
                                          <div
                                            class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                                          >
                                            <div
                                              class="d-flex ng-star-inserted"
                                              style="max-width: 500px"
                                            >
                                              <span
                                                class="ng-star-inserted text-ellipsis"
                                                >{{
                                                  repartition.get('name')?.value
                                                }}</span
                                              >
                                            </div>
                                          </div>
                                          <div
                                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                                          >
                                            <div
                                              class="d-flex ng-star-inserted"
                                              style="max-width: 300px"
                                            >
                                              <span class="ng-star-inserted"
                                                ><input
                                                  notdot
                                                  class="full-w"
                                                  formControlName="repartition" /></span
                                              ><span
                                                style="margin-left: 3px"
                                                class="ng-star-inserted"
                                                >%</span
                                              >
                                            </div>
                                          </div>
                                          <div
                                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                                            style="
                                              line-height: 16px;
                                              display: flex;
                                              align-items: center;
                                              color: #6c6c6c;
                                              font-size: 12px;
                                            "
                                          >
                                            <div
                                              class="d-flex ng-star-inserted"
                                              style="max-width: 300px"
                                            >
                                              <span
                                                style="margin-right: 3px"
                                                class="ng-star-inserted"
                                                >soit </span
                                              ><span class="ng-star-inserted">
                                                {{
                                                  getTotalAv(
                                                    repartition.value,
                                                    options?.parameters
                                                      ?.avOptionInvestissementProgressifMontantArbitrage
                                                  )
                                                }}
                                                &nbsp;€
                                              </span>
                                            </div>
                                          </div>
                                          <!-- remove -->
                                          <div
                                            class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                                          >
                                            <div
                                              class="d-flex ng-star-inserted"
                                              style="
                                                max-width: 300px;
                                                justify-content: flex-end;
                                              "
                                            >
                                              @if (
                                                avOptionInvestissementProgressifRepartition.length >
                                                1
                                              ) {
                                                <pr-button-confirm
                                                  class="confirm"
                                                  display="danger"
                                                  size="sm"
                                                  clazz="pr-toolbar-button last"
                                                  icon="delete_forever"
                                                  title="Suppression"
                                                  comment="Toute suppression est définitve, les données seront perdues."
                                                  labelConfirm="Supprimer"
                                                  labelCancel="Annuler"
                                                  (onConfirm)="
                                                    deleteFields(index)
                                                  "
                                                >
                                                  Êtes-vous sûr(e) de vouloir
                                                  supprimer
                                                  <em
                                                    >“{{
                                                      avOptionInvestissementProgressifRepartition
                                                        ?.controls[index]?.value
                                                        ?.name
                                                    }}”</em
                                                  >
                                                </pr-button-confirm>
                                              }
                                            </div>
                                          </div>
                                          <!-- remove -->
                                        </div>
                                      </div>
                                    </ng-container>
                                  }
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </pr-panel-body>
                    </div>
                  </pr-panel>
                  <pr-color-panel [display]="allocationPanel.display">
                    <pr-panel-body clazz="pam">
                      <pr-label
                        [name]="allocationPanel.icon"
                        [width]="18"
                        [height]="18"
                        >{{ allocationPanel.text }}</pr-label
                      >
                    </pr-panel-body>
                  </pr-color-panel>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
